import * as React from 'react';
import DisciplinePage from '../../Components/DisciplinePage/DisciplinePage';
import Image from '../../img/bag-page.webp';

const SECTIONS = [
  {
    heading: 'Tecniche ed esercizi con il sacco',
    body: "Gli esercizi con il sacco variano da semplici colpi di base a combinazioni più complesse, adatti a tutti i livelli di esperienza. Permette ai praticanti di migliorare la propria resistenza e forza. L'istruttore può guidare i praticanti attraverso una serie di esercizi che aiutano a migliorare la velocità, la precisione e la potenza.",
  },
  {
    heading: 'Il sacco come strumento di crescita',
    body: "Nella Muay Thai, allenarsi con il sacco non è solo un esercizio fisico, ma anche un percorso di crescita personale. L'allenamento costante insegna ai praticanti a gestire la loro energia e la loro forza in modo più efficiente. Si impara a mantenere la calma e la concentrazione anche in situazioni di stress, trasformando l'allenamento fisico in un momento di sviluppo personale e di autocontrollo. La pratica regolare con il Bag non solo migliora le abilità di combattimento, ma anche la resistenza mentale e la fiducia in se stessi.",
  },
];

export default function BagPage() {
  return (
    <DisciplinePage
      kicker="Attività 01"
      title="BAG"
      intro="Il sacco è uno strumento fondamentale per chi pratica Muay Thai, essenziale per sviluppare resistenza, potenza e coordinazione. Offre ai praticanti un modo sicuro ed efficace per allenarsi, essendo particolarmente utile per perfezionare la tecnica."
      sections={SECTIONS}
      image={Image}
    />
  );
}
